export const archivedProjects = {
  farman: {
    to: "https://cdn.arnocellarier.fr/s/ac/arch/fmn.pfv1.pdf"
  }
};